import { Sidebar as SemanticSidebar } from 'semantic-ui-react';

export { SidebarProps, StrictSidebarProps } from 'semantic-ui-react';

export const Sidebar: typeof SemanticSidebar = SemanticSidebar;

export default Sidebar;
